export default {
  showModal: state => state.isModalShow = true,
  setMessage: (state, message) => state.message = message
}